var map = {
	"./1.png": "2a0e",
	"./2.png": "777a",
	"./6.png": "12fa",
	"./bg.png": "bf59",
	"./content01.png": "a0c8",
	"./content02.png": "39e7",
	"./content03.png": "7834",
	"./icon1.png": "286f",
	"./icon2.png": "3196",
	"./icon3.png": "63c6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a7da";